<template>
    <a-drawer
        :title="is_add == '1' ? $t('program.changeProgram') /* 修改日程 */ : $t('program.add_title') /* 添加讲题讲者 */"
        width="800"
        placement="right"
        :closable="true"
        :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
        :visible="visible"
        @close="handleDrawerClose"
    >
        <a-spin tip="Loading..." :spinning="spinning">
            <!-- 基本信息 -->
            <a-card size="small" :title="$t('program.session_info') /* Session信息 */">
                <date-hall-form
                    ref="dateHallFormRef"
                    :is_type="is_add == 1 ? 'edit' : 'add'"
                    :sessionInfo="{ ...sessionInfo, ...programInfo, session_id: sessionInfo.id }"
                    :sessionList="sessionList"
                    :hallList="hallList"
                    :dateList="dateList"
                    :isSub="isSub"
                ></date-hall-form>
            </a-card>
            <a-card class="mt15" size="small" :title="$t('program.question') /* 题目 */">
                <template slot="extra">
                    <div style="color: red">
                        {{
                            is_add != 1
                                ? $t('program.add_title_tips' /* 注意：请直接搜索稿件标题，未查询到再新增 */)
                                : $t('program.add_title_speaker_tips') /* 注意：修改日程时，直接修改题目会同时更改对应稿件标题，如需更换稿件请直接搜索。 */
                        }}
                    </div>
                </template>
                <search-title ref="searchTitleRef" :programInfo="programInfo" :userType="userType" :abstract_list="listObj.abstract_list" @setUser="setUserInfoFun" />
            </a-card>
            <div class="common-title mt15"></div>
            <a-card size="small" :title="$t('program.title_speaker') /* 讲题讲者 */">
                <a-form :form="searchUserForm">
                    <search-user :userInfo="userInfo" :form="searchUserForm" :userType="userType" ref="searchUserRef"></search-user>
                </a-form>
            </a-card>
            <a-card class="mt15" size="small" :title="$t('program.service_fee') /* 劳务费 */">
                <a-form class="session-form" :form="labourForm">
                    <a-row :gutter="[15, 15]">
                        <a-col :span="24">
                            <a-form-item style="width: 100%" :label="$t('program.has_service_fee') /* 是否有劳务费 */">
                                <a-radio-group v-decorator="['is_servicefee', { rules: [{ required: true, message: $t('program.p_has_service_fee') /* 请选择是否有劳务费 */ }] }]">
                                    <a-radio-button class="mb5" :value="1">{{ $t('formConfig.yes') /* 是 */ }}</a-radio-button>
                                    <a-radio-button class="mb5" :value="0">{{ $t('formConfig.no') /* 否 */ }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <div v-show="labourForm.getFieldValue('is_servicefee') == 1">
                            <a-col :span="24">
                                <a-form-item style="width: 100%" :label="$t('program.currency') /* 币种 */">
                                    <a-select
                                        :placeholder="$t('program.p_currency') /* 请选择币种 */"
                                        v-decorator="['currency', { rules: [{ required: labourForm.getFieldValue('is_servicefee') == 1, message: $t('program.p_currency') /* 请选择币种 */ }] }]"
                                    >
                                        <a-select-option v-for="(item, index) in listObj.currency_type" :key="index" :value="item.id">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>

                            <a-col :span="24">
                                <a-form-item style="width: 100%" :label="$t('program.service_fee_amount') /* 劳务费金额 */">
                                    <a-input-number
                                        style="width: 100%"
                                        :placeholder="$t('program.please_fill_service_fee_amount') /* 劳务费金额 */"
                                        :min="0"
                                        v-decorator="[
                                            'servicefee',
                                            { rules: [{ required: labourForm.getFieldValue('is_servicefee') == 1, message: $t('program.please_fill_service_fee_amount') /* 劳务费金额 */ }] }
                                        ]"
                                    ></a-input-number>
                                </a-form-item>
                            </a-col>
                        </div>
                    </a-row>
                </a-form>
            </a-card>
            <a-card class="mt15" size="small" :title="$t('program.person_in_charge') /* 负责人 */">
                <a-form class="session-form" :form="principalForm">
                    <a-row :gutter="[15, 0]">
                        <a-col :span="24">
                            <a-form-item style="width: 100%" :label="$t('program.person_in_charge') /* 负责人 */">
                                <a-select v-decorator="['follow_user_id', { rules: [{ required: false }] }]">
                                    <a-select-option :value="item.user_id" v-for="(item, index) in listObj.fzr_list" :key="index">
                                        {{ item.real_name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[15, 0]">
                        <a-col :span="24">
                            <a-form-item style="width: 100%" :label="$t('formConfig.remark') /* 备注 */">
                                <a-textarea
                                    :placeholder="$t('program.hall_remarks_placeholder') /* 请填写备注 */"
                                    v-decorator="['remarks_admin', { rules: [{ required: false, message: $t('program.hall_remarks_placeholder') /* 请填写备注 */ }] }]"
                                ></a-textarea>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
        </a-spin>
        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 99
            }"
        >
            <a-button type="default" @click="visible = false">{{ $t('web.cancel' /* 取消 */) }}</a-button>
            <a-button :loading="loading" :disabled="loading" class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('web.ok' /* 确定 */) }}</a-button>
        </div>
    </a-drawer>
</template>

<script>
const labourFields = ['is_servicefee', 'currency', 'servicefee'];
const principalFields = ['follow_user_id', 'remarks_admin'];
import searchTitle from './search-title.vue';
import moment from 'moment';
import searchUser from '@/components/search-user';
import dateHallForm from './date-hall-form.vue';
import pick from 'lodash.pick';
export default {
    components: {
        searchTitle,
        searchUser,
        dateHallForm
    },
    name: 'addTitleSpeaker',
    props: {
        sessionInfo: {
            default: () => {},
            tyoe: Object
        },
        // session列表
        sessionList: {
            default: () => [],
            type: Array
        },
        // 日期列表
        dateList: {
            default: () => [],
            type: Array
        },
        // 会场列表
        hallList: {
            default: () => [],
            type: Array
        },
        isSub: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            labourForm: this.$form.createForm(this), // 劳务
            principalForm: this.$form.createForm(this), // 负责人
            spinning: false,
            programInfo: {},
            listObj: {},
            userInfo: {},
            is_add: '1', // 1更新 0新增
            userType: 'cn',
            channel_list: [],
            searchUserForm: this.$form.createForm(this)
        };
    },
    computed: {},
    watch: {
        sessionInfo: {
            handler(newVal) {
                console.log(newVal);
            }
        }
    },
    methods: {
        show(id, lang) {
            this.userType = lang;
            this.visible = true;
            if (id) {
                this.is_add = '1';
                this.getProgramInfo(id);
            } else {
                // 新增时，如何已经有日程，开始时间是最后一条的结束时间 结束时间通过时长计算
                this.is_add = '0';
            }
            this.getProgramFormList();
        },
        setUserInfoFun(info) {
            this.userInfo = info;
            if (Object.keys(info).length == 0) {
                this.$refs.searchUserRef.reset();
            }
        },
        getProgramInfo(program_id) {
            this.$request.get({ url: 'getProgramInfo', data: { program_id } }).then(res => {
                this.programInfo = res.data;
                this.labourForm.setFieldsValue(pick(this.programInfo, labourFields));
                this.getDutyInfo(this.programInfo.duty_id);
            });
        },
        getDutyInfo(duty_id) {
            this.$request.get({ url: 'getDutyInfo', data: { duty_id } }).then(res => {
                this.userInfo = res.data;
                this.userInfo.id = this.userInfo.user_id;
            });
        },

        //关闭弹窗
        handleDrawerClose() {
            this.$refs.dateHallFormRef.reset();
            this.labourForm.resetFields();
            this.$refs.searchTitleRef.reset();
            this.$refs.searchUserRef.reset();
            this.visible = false;
        },
        principalFormValidate() {
            return new Promise((resolve, reject) => {
                this.principalForm.validateFields((err, values) => {
                    if (!err) {
                        resolve(values);
                    }
                });
            });
        },
        labourFormValidate() {
            return new Promise((resolve, reject) => {
                this.labourForm.validateFields((err, values) => {
                    if (!err) {
                        resolve(values);
                    }
                });
            });
        },
        handleSubmitEvent() {
            let arr = [this.$refs.dateHallFormRef.validate(), this.$refs.searchTitleRef.validate(), this.labourFormValidate(), this.principalFormValidate(), this.$refs.searchUserRef.validate()];
            Promise.all(arr).then(res => {
                this.spinning = true;
                let data = {};
                res.forEach((item, index) => {
                    for (let i in item) {
                        if (i == 'starttime_slot' || i == 'endtime_slot') {
                            data[i] = moment(item[i]).format('HH:mm');
                        } else {
                            data[i] = item[i];
                        }
                    }
                });
                data.duty_id = this.programInfo.duty_id;
                data.program_id = this.programInfo.id;
                if (!this.isSub) {
                    data.session_id = this.sessionInfo.id;
                } else {
                    data.t_id = this.sessionInfo.id;
                }
                data.sys_uid = res[4].id; // 讲题讲者用户id
                data.user_id = res[4].id;
                data.userid = res[4].id;
                data.is_add = this.is_add;
                delete data.id; // 删除用户id
                // 新增论文 通道id
                if (!data.channel_id) {
                    data.channel_id = this.listObj.channel_list[0].id;
                }
                // 分类id
                if (!data.class_id) {
                    let classList = this.listObj.abs_list.forEach(it => it.name == '日程');
                    data.class_id = classList?.[0]?.id;
                }
                data.is_abstract = '1';
                this.$request
                    .post({ url: 'updateCreateProgram', data })
                    .then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('web.operate_scuuess') /* 操作成功 */);
                            this.handleDrawerClose();
                            this.$emit('update');
                        }
                    })
                    .finally(() => {
                        this.spinning = false;
                    });
            });
        },
        getProgramFormList() {
            this.$request.get({ url: 'getProgramFormList', data: { add_language: 'cn', session_id: this.sessionInfo.id } }).then(res => {
                this.listObj = res.data;
            });
        }
    },
    created() {
        labourFields.forEach(v => this.labourForm.getFieldDecorator(v));
        principalFields.forEach(v => this.principalForm.getFieldDecorator(v));
    },
    mounted() {}
};
</script>
<style lang='less' scoped>
/deep/.ant-drawer-body {
    background: #f8fafe;
}
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
</style>